import useSWR from 'swr'
import { getDefaultFeeSet } from './api'
import { useHermesSdkConfig } from '../../use-hermes-sdk-config'

export const useDefaultFeeSet = () => {
  const config = useHermesSdkConfig()

  return useSWR('/fees/fee-set/default', () => getDefaultFeeSet(config))
}
